<template>
  <section>
    <div class="rounded-lg bg-white overflow-hidden shadow">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <ui-block-editor>

        </ui-block-editor>
      </div>
    </div>
  </section>
</template>

<script>
import UiBlockEditor from "@/components/ui/content/UiBlockEditor";
export default {
  name: "Help",
  components: {UiBlockEditor}
}
</script>

<style scoped>

</style>